import { useEffect } from 'react';

import { ApplicationEvent, PageView } from '../../../models/analytics';
import { useAnalytics } from '../../../core/Analytics/AnalyticsProvider';
import { ProviderEntity } from '../../../models/provider';
import { useLegal } from '../../ApplicationProviders/LegalProvider/LegalProvider';
import {
  LegalDisclaimerAuth as LegalDisclaimerAuthImport,
  LegalDisclaimerAuthOwnProps,
} from '../../screens/molecules/LegalDisclaimer/LegalDisclaimerAuth/LegalDisclaimerAuth';
import { FooterLegalDisclaimer, FooterText } from '../../atoms/Footer/Footer';

export type LegalDisclaimerPresenterProps = {
  provider?: ProviderEntity;
  pageView: PageView;
  LegalDisclaimerAuth?: React.ComponentType<LegalDisclaimerAuthOwnProps>;
};

export const LegalDisclaimer: React.FC<LegalDisclaimerPresenterProps> = ({
  provider,
  pageView,
  LegalDisclaimerAuth = LegalDisclaimerAuthImport,
}) => {
  const { tinklinkAnalytics } = useAnalytics();
  const { hasUserReadLegalDisclaimer, setLegalDisclaimerPageView } = useLegal();

  useEffect(() => {
    if (!hasUserReadLegalDisclaimer(pageView)) {
      setLegalDisclaimerPageView(pageView);
      tinklinkAnalytics.sendApplicationEventOnce(ApplicationEvent.LEGAL_DISCLAIMER_READ);
    }
  }, [pageView, tinklinkAnalytics, hasUserReadLegalDisclaimer, setLegalDisclaimerPageView]);

  if (hasUserReadLegalDisclaimer(pageView)) {
    return null;
  }

  return (
    <FooterLegalDisclaimer stickToBottom alignItems="start">
      <FooterText>
        <LegalDisclaimerAuth provider={provider} />
      </FooterText>
    </FooterLegalDisclaimer>
  );
};
